import { TafiffSummary } from '../api/tariffSummaryApi';
import { CellLayout } from 'src/common/components/ConfigurableTable/Components/Cells/CellLayout';
import { GetElementType } from 'src/common/tsHelpers';
import { TariffSummaryUsageCellDisplay } from './TariffSummaryUsageCellDisplay';
import { getHuminizeDurationInSecFunction } from 'src/i18n/dateLocale';
import React from 'react';

type TariffSummarySMSUsageCellProps = {
  row: GetElementType<TafiffSummary['items']>;
};

const humanize = getHuminizeDurationInSecFunction(['m', 's'], true);

export const TariffSummaryVoiceUsageCell = React.memo(
  ({
    row: {
      usedSeconds,
      allowanceSeconds,
      forecastSeconds,
      consumptionLevelUsedSeconds,
      consumptionLevelForecastUsedSeconds,
    },
  }: TariffSummarySMSUsageCellProps) => {
    return (
      <CellLayout>
        <TariffSummaryUsageCellDisplay
          {...(usedSeconds == null
            ? { usage: null, forecast: null, allowence: null, consumptionLevelUsage: null, consumptionLevelForecast: null }
            : { usage: usedSeconds, forecast: forecastSeconds!, allowence: allowanceSeconds!, consumptionLevelUsage: consumptionLevelUsedSeconds!, consumptionLevelForecast: consumptionLevelForecastUsedSeconds! }
          )}
          valueFormater={humanize}
        />
      </CellLayout>
    );
  },
);
